// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6c85d72c","397":"ec233091","411":"f36dbe75","453":"69b360b5","766":"c93ce9ae","886":"e43946c4","982":"6d3e60da"}[chunkId] + ".chunk.js";
};